import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #1e958c 0%, #0b4f6c 40%, #f5f7fb 100%);
  
  &.fullscreen-mode {
    /* Quando em modo tela cheia, ajustar para ocupar toda a tela */
    height: 100vh;
    overflow: hidden;
    /* z-index baixo para não interferir com modais */
    z-index: 1;
  }
`;

export const ContentArea = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 16px auto 24px;
  padding: 20px 16px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  gap: 18px;
  backdrop-filter: blur(8px);
  
  /* Quando em modo fullscreen, ajustar para ocupar mais espaço */
  .fullscreen-mode & {
    max-width: 95%;
    margin: 8px auto;
    padding: 16px;
    border-radius: 12px;
    height: calc(100vh - 16px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
`;

export const PageTitle = styled.h2`
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1e958c;
  margin: 4px auto 16px;
  
  /* Quando em modo fullscreen, ajustar tamanho */
  .fullscreen-mode & {
    font-size: 20px;
    margin: 0 0 12px 0;
  }
`;

export const PDVArea = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 24px;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: #f5f7fb;
  border-radius: 12px;
`;

export const ProductsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: #f5f7fb;
  border-radius: 12px;
  max-height: calc(100vh - 200px);
  min-height: 500px;
  overflow-y: auto;
  
  /* Quando em modo fullscreen, ajustar altura */
  .fullscreen-mode & {
    max-height: calc(100vh - 120px);
    min-height: 400px;
  }
  
  /* Estilização da scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #1e958c;
    border-radius: 4px;
    
    &:hover {
      background: #0b4f6c;
    }
  }
`;

export const CartArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: #f5f7fb;
  border-radius: 12px;
  position: sticky;
  top: 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  
  /* Quando em modo fullscreen, ajustar altura */
  .fullscreen-mode & {
    max-height: calc(100vh - 120px);
  }
  
  /* Estilização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #1e958c;
    border-radius: 4px;
    
    &:hover {
      background: #0b4f6c;
    }
  }
`;

export const CartItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  overflow-y: auto;
  padding: 4px;
  min-height: 200px;
`;

export const CartItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.2s;
  
  &:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }
`;

export const CartTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  background: #1e958c;
  color: white;
  border-radius: 8px;
  font-weight: 600;
  font-size: 18px;
  margin-top: auto;
  box-shadow: 0 2px 8px rgba(30, 149, 140, 0.3);
`;

export const StudentInfo = styled.div`
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const ProductCard = styled.div`
  padding: 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  border: 2px solid transparent;
  opacity: ${props => props.disabled ? 0.5 : 1};
  overflow: visible;
  position: relative;
  
  &:hover {
    ${props => !props.disabled && `
      box-shadow: 0 6px 12px rgba(30, 149, 140, 0.2);
      transform: translateY(-3px);
      border-color: #1e958c;
    `}
  }
  
  &:active {
    ${props => !props.disabled && `
      transform: translateY(-1px);
    `}
  }
  
  ${props => props.selected && `
    background: #e3f2fd;
    border: 2px solid #1e958c;
  `}
`;

export const ProductName = styled.div`
  font-weight: 600;
  color: #0b4f6c;
  margin-bottom: 4px;
`;

export const ProductPrice = styled.div`
  font-size: 14px;
  color: #1e958c;
  font-weight: 700;
`;
